// Copies the href of an `a.clipboard` link to the clipboard.
// The link stays a normal link. Without JS or the Clipboard API, the link opens its URL.
const COPIED_TEXT = "Link Copied!";
const RESET_DELAY = 2000;

//#region Clipboard
if (navigator.clipboard && document.querySelector("a.clipboard[href]")) {
  // Screen readers do not always read a text change on the focused link.
  // This live region tells them the result.
  const status = document.createElement("span");
  status.className = "sr-only";
  status.setAttribute("role", "status");
  document.body.appendChild(status);

  document.addEventListener("click", event => {
    const link = /** @type HTMLAnchorElement */ (event.target).closest("a.clipboard[href]");

    // Do not copy when an author edits the content in SAM.
    if (!link || link.closest(".mce-content-body")) {
      return;
    }

    event.preventDefault();

    navigator.clipboard.writeText(link.href).then(() => {
      // Keep the original text on the first click only.
      // A second click before the reset must not save "Link Copied!" as the original text.
      if (!link.dataset.clipboardText) {
        link.dataset.clipboardText = link.textContent;
      }
      link.textContent = COPIED_TEXT;
      status.textContent = COPIED_TEXT;

      clearTimeout(link.clipboardTimer);
      link.clipboardTimer = setTimeout(() => {
        link.textContent = link.dataset.clipboardText;
        delete link.dataset.clipboardText;
        status.textContent = "";
      }, RESET_DELAY);
    }, () => {
      // The browser did not let us copy. Open the URL, as the link does without JS.
      window.location.href = link.href;
    });
  });
}
//#endregion
